import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators, FormBuilder, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { UserService } from '../../services/userService';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-change-password',
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    CommonModule 
  ],
  templateUrl: './change-password.component.html',
  styleUrl: './change-password.component.css'
})

export class ChangePasswordComponent {
  Error: boolean =false;
  Message: string="";

  changePasswordForm = new FormGroup({
    currentPassword: new FormControl('', { nonNullable: true, validators: Validators.required } ),
    password: new FormControl('', { nonNullable: true, validators: [Validators.required, Validators.pattern(new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[#$^+=!*()@%&]).{8,}$'))] }),
    confirmPassword: new FormControl('', { nonNullable: true, validators: [Validators.required, Validators.pattern(new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[#$^+=!*()@%&]).{8,}$'))] })
  });

  constructor(private formBulder: FormBuilder,
    private userService: UserService,
    private router: Router,
    private authService: AuthService
  ) {
    
  }

  isMatch(): boolean {

    return this.changePasswordForm.controls['password'].value == this.changePasswordForm.controls['confirmPassword'].value;
  }

  IsValid(): boolean {
    return !this.changePasswordForm.invalid && this.isMatch();
  }

  changePassword(formData : any) {
    this.userService.changePassword(formData).subscribe(data => {
      if (data) {
        if (!this.authService.IsAuthenticated()) {
          this.authService.authenticate();
        }
        else {
          this.Error = false;
          this.Message = "The Password has been changed!"
        }
      }
      else {
        this.Error = true;
        this.Message = "Error with changing the password!"
      }
    });
  }

}
